import React, { useEffect, useState } from 'react';
import axios from '../../helper/axios';
import { Bar } from 'react-chartjs-2';

const DashChart = () => {
    const [chartData, setChartData] = useState({});

    useEffect(() => {
        const filter = {isall:1}
        // Fetch data from the API endpoint
        axios
            .post('/product_read',filter) // Replace '/product_read' with your actual API endpoint
            .then((response) => {
                const apiData = response.data.data;

                if (!Array.isArray(apiData) || apiData.length === 0) {
                    // If apiData is not an array or is empty, handle the error accordingly
                    console.error('API data is empty or not in the correct format');
                    return;
                }

                // Process the API data and extract required values for the chart
                const labels = apiData.map((item) => item.label);
                const values = apiData.map((item) => item.value);

                // Set the chart data
                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Data Values',
                            data: values,
                            backgroundColor: 'rgba(75, 192, 192, 0.6)', // You can customize the color as per your preference
                        },
                    ],
                });
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, []);

    return (
        <>
            {/* // <div>
        //     <h2>Bar Chart</h2>
        //     {chartData.labels && chartData.labels.length > 0 ? (
        //         <div>
        //             <Bar
        //                 data={chartData}
        //                 options={{
        //                     maintainAspectRatio: false, // Adjust as per your layout requirements
        //                     scales: {
        //                         x: {
        //                             type: 'category', // Use category scale for x-axis
        //                             labels: chartData.labels,
        //                         },
        //                     },
        //                 }}
        //             />
        //         </div>
        //     ) : (
        //         <div>No data available for the chart.</div>
        //     )}
    // </div>*/}


            {/* <h4>dashboard</h4> */}
        </>
    );
};

export default DashChart;